import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import {
  addToCartAPI,
  completeOrderAPI,
  deleteProductAPI,
  fetchOrdersAPI,
  getCartDetailsAPI,
  placeOrderAPI,
  productDetailAPI,
  productsAPI,
  relatedProductAPI,
  sendProductFeedbackAPI,
  updateCartAPI,
} from "../../routes/apiEndPoints";

export const fetchOrders = createAsyncThunk("fetch-orders", async () => {
  try {
    const response = await API_REQUEST({
      url: fetchOrdersAPI,
      method: "GET",
    });
    return response;
  } catch (error) {}
});
export const fetchProducts = createAsyncThunk("fetch-products", async () => {
  try {
    const response = await API_REQUEST({
      url: productsAPI,
      method: "GET",
    });
    return response;
  } catch (error) {}
});
export const fetchProductDetail = createAsyncThunk(
  "fetch-product-detail",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: productDetailAPI + `/${props}`,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);
export const fetchRelatedProduct = createAsyncThunk(
  "fetch-related-products",
  async (props) => {
    try {
      const response = await API_REQUEST({
        url: relatedProductAPI + `/${props}`,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

export const sendProductFeedback = createAsyncThunk(
  "send-product-feedback",
  async (props) => {
    try {
      const { payload, callback } = props;
      const response = await API_REQUEST({
        url: sendProductFeedbackAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {}
  }
);

export const addToCart = createAsyncThunk("add-to-cart", async (props) => {
  try {
    const { payload, callback } = props;
    const response = await API_REQUEST({
      url: addToCartAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {}
});

export const fetchCartDetails = createAsyncThunk(
  "fetch-card-details",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getCartDetailsAPI,
        method: "GET",
      });
      return response;
    } catch (error) {}
  }
);

export const updateCartDetail = createAsyncThunk(
  "update-card-detail",
  async (props) => {
    try {
      const { payload, callback } = props;
      const response = await API_REQUEST({
        url: updateCartAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {}
  }
);
export const deleteProduct = createAsyncThunk(
  "delete-porduct",
  async (props) => {
    try {
      const { payload, callback } = props;
      const response = await API_REQUEST({
        url: deleteProductAPI,
        method: "POST",
        data: payload,
      });
      callback(response);
      return response;
    } catch (error) {}
  }
);

export const placeOrder = createAsyncThunk("place-order", async (props) => {
  try {
    const { payload, callback } = props;
    const response = await API_REQUEST({
      url: placeOrderAPI,
      method: "POST",
      data: payload,
    });
    callback(response);
    return response;
  } catch (error) {}
});

export const updateOrderStatus = createAsyncThunk(
  "update-order-status",
  async (props) => {
    try {
      const { payload, callback } = props;
      const response = await API_REQUEST({
        url: completeOrderAPI,
        method: "POST",
        data: payload,
        isErrorToast:false,
        // isSuccessToast: false
      });
      callback(response);
      return response;
    } catch (error) {}
  }
);
